import * as React from 'react';

import EnterprisePageHeaderBffProvider from 'bundles/composable-page-header-enterprise/providers/EnterprisePageHeaderBffProvider';
import EnterpriseDomainPillsProvider from 'bundles/page-config-common/providers/enterprise-skills/EnterpriseDomainPillsProvider';
import EnterpriseSkillsProvider from 'bundles/page-config-common/providers/enterprise-skills/EnterpriseSkillsProvider';
import EnterprisePermittedProductsDataProvider from 'bundles/unified-common/providers/EnterprisePermittedProductsDataProvider';
import EnterpriseOrgScopedPageDataProvider from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgScopedPageDataProvider';
import EnterpriseOrgUserExperienceHandler from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgUserExperienceHandler';
import OrgScopedSkillsProvider from 'bundles/unified-home-common/providers/enterprise/org-scoped/OrgScopedSkillsProvider';
import OrgScopedDomainsProvider from 'bundles/unified-home-common/providers/org-scoped/data/OrgScopedDomainsProvider';

const DefaultEnterprisePageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseOrgUserExperienceHandler>
      <EnterprisePageHeaderBffProvider>
        <EnterpriseOrgScopedPageDataProvider>
          <OrgScopedDomainsProvider>
            <OrgScopedSkillsProvider>
              <EnterpriseDomainPillsProvider>
                <EnterpriseSkillsProvider>
                  <EnterprisePermittedProductsDataProvider>{children}</EnterprisePermittedProductsDataProvider>
                </EnterpriseSkillsProvider>
              </EnterpriseDomainPillsProvider>
            </OrgScopedSkillsProvider>
          </OrgScopedDomainsProvider>
        </EnterpriseOrgScopedPageDataProvider>
      </EnterprisePageHeaderBffProvider>
    </EnterpriseOrgUserExperienceHandler>
  );
};

export default DefaultEnterprisePageHeaderProvider;
